import { Controller } from "@hotwired/stimulus";
import Swiper from 'swiper';
import { Navigation } from 'swiper/modules';

export default class extends Controller {
    static targets = ['slide', 'next', 'prev'];

    connect() {
        this.swiper = new Swiper(this.element, {
            modules: [Navigation],
            slidesPerView: 1,
            slidesPerGroup: 1,
            spaceBetween: 96,
            grabCursor: true,
            loop: true,
            watchSlidesProgress: true,
            roundLengths: true,
            autoHeight: true,
            breakpoints: {
                640: {
                    slidesPerView: 2,
                    slidesPerGroup: 1,
                    spaceBetween: 24,
                },
                800: {
                    slidesPerView: 3,
                    slidesPerGroup: 1,
                    spaceBetween: 32,
                },
                1024: {
                    slidesPerView: 3,
                    slidesPerGroup: 1,
                    spaceBetween: 40,
                },
            },
            navigation: {
                nextEl: this.nextTarget,
                prevEl: this.prevTarget,
            },
        });
    }

    disconnect() {
        this.swiper?.destroy(true, true);
        this.swiper = null;
    }
}
